// UTM tracking utilities

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const UTM_STORAGE_KEY = 'utm_params';

/**
 * Extract UTM parameters from URL and store them in sessionStorage
 */
export const captureUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmData = {};
  let hasUTM = false;

  UTM_PARAMS.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      utmData[param] = value;
      hasUTM = true;
    }
  });

  if (hasUTM) {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmData));
  }
};

/**
 * Get stored UTM parameters
 */
export const getUTMParams = () => {
  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error reading UTM params:', error);
    return {};
  }
};

/**
 * Clear stored UTM parameters
 */
export const clearUTMParams = () => {
  sessionStorage.removeItem(UTM_STORAGE_KEY);
};
